import queryString from "query-string";

export default {
  setAdvertisement: advertisement => ({ ...advertisement, _suppressRenderWarning: true }),
  fetch: () => async (state, actions) => {
    const adOptions = {
      content_type: "player",
      page_path: window.location.pathname,
      size: "desktop_and_mobile_player"
    };

    return fetch(`/ads.json?${queryString.stringify(adOptions)}`, {
      method: "GET",
      credentials: "same-origin",
      headers: {
        accept: "application/json"
      }
    })
      .then(response => {
        // A 204 status code is returned if no ad is found
        if (response.status !== 200) {
          return {};
        }
        return response.json();
      })
      .then(advertisement => {
        actions.setAdvertisement(advertisement);
        return advertisement;
      });
  }
};
